import * as React from "react";

function SvgCheckCircleSmall(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={16}
      height={16}
      {...props}
    >
      <defs>
        <path
          d="M7.16 8.86L5.29 6.99 4.27 8l2.89 2.89 6.39-6.39c.19.3.36.62.5.95.34.8.51 1.66.51 2.55 0 .89-.17 1.75-.51 2.55a6.76 6.76 0 01-1.41 2.09c-.6.6-1.31 1.07-2.09 1.41-.8.34-1.66.51-2.55.51-.89 0-1.75-.17-2.55-.51a6.76 6.76 0 01-2.09-1.41 6.76 6.76 0 01-1.41-2.09c-.34-.8-.51-1.66-.51-2.55 0-.89.17-1.75.51-2.55.34-.78.81-1.49 1.41-2.09.6-.6 1.31-1.07 2.09-1.41.8-.34 1.66-.51 2.55-.51.83 0 1.63.15 2.39.45.11-.11.98-.99 1.09-1.09A7.998 7.998 0 000 8c0 4.42 3.58 8 8 8s8-3.58 8-8c0-1.69-.52-3.25-1.41-4.54a7.6 7.6 0 00-.93-1.11l-6.5 6.51z"
          id="check-circle-small_svg__a"
        />
      </defs>
      <use xlinkHref="#check-circle-small_svg__a" fill="#66aef2" />
      <use
        xlinkHref="#check-circle-small_svg__a"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
    </svg>
  );
}

export default SvgCheckCircleSmall;
